import store from '@/store';

const DashboardView = () => import(/* webpackChunkName: "dashboard" */ './views/DashboardView');
const DashboardHomeView = () => import(/* webpackChunkName: "dashboard" */ './views/DashboardHomeView');
const DashboardProfileView = () => import(/* webpackChunkName: "dashboard" */ './views/DashboardProfileView');
const DashboardLifeskillView = () => import(/* webpackChunkName: "dashboard" */ './views/DashboardLifeskillView');
const DashboardScenarioView = () => import(/* webpackChunkName: "dashboard" */ './views/DashboardScenarioView');
const DashboardVideoView = () => import(/* webpackChunkName: "dashboard" */ './views/DashboardVideoView');
const MemolifeTvView = () => import(/* webpackChunkName: "dashboard" */ './views/MemolifeTvView');

const DashboardOnboardingIntroView = () =>
    import(/* webpackChunkName: "dashboard" */ './views/DashboardOnboardingIntroView');
const DashboardLifeskillsFavoritesView = () =>
    import(/* webpackChunkName: "dashboard" */ './views/DashboardLifeskillsFavoritesView');
const DashboardLifeskillsVoteView = () =>
    import(/* webpackChunkName: "dashboard" */ './views/DashboardLifeskillsVoteView');

const MentalHygieneView = () => import(/* webpackChunkName: "dashboard" */ './views/MentalHygieneView');
const CreateTeamChallengeView = () =>
    import(/* webpackChunkName: "dashboard" */ './views/TeamChallenge/CreateTeamChallenge');

export default [
    {
        path: '/do-not-use-this-path',
        component: DashboardView,
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: '/home',
                name: 'DashboardHomeView',
                component: DashboardHomeView,
                meta: {
                    canShowUpgrade: true
                },
                beforeEnter(to, from, next) {
                    if (!store.state.moduleApp.memolife.didShowDashboardOnboarding) {
                        return next({
                            name: 'DashboardOnboardingIntroView'
                        });
                    }
                    next();
                }
            },
            {
                path: '/profile',
                name: 'DashboardProfileView',
                // component: DashboardProfileView
                redirect: {
                    name: 'DashboardProfileLifeViewWithTab',
                    params: {
                        tabId: 'life'
                    }
                }
            },
            {
                path: '/profile/:tabId',
                name: 'DashboardProfileLifeViewWithTab',
                props: true,
                component: DashboardProfileView
            },

            {
                path: '/from-rep-email',
                beforeEnter(to, from, next) {
                    store.commit('moduleApp/setInitiallyOpenNotificationDropdown', true);
                    next({
                        name: 'DashboardHomeView'
                    });
                }
            },
            {
                path: '/videos',
                name: 'MemolifeTvView',
                component: MemolifeTvView
            },
            {
                path: '/create-team-challange/:teamId',
                name: 'CreateTeamChallange',
                props: true,
                component: CreateTeamChallengeView
            }
        ]
    },

    {
        path: '/video/:videoId/:lifeskillId?',
        name: 'DashboardVideoView',
        props: true,
        component: DashboardVideoView
    },
    {
        path: '/lifeskill/:lifeskillId',
        name: 'DashboardLifeskillView',
        props: true,
        component: DashboardLifeskillView
    },
    {
        path: '/lifeskill/02/practice/games',
        name: 'DashboardLifeskillViewActiveGamesTab',
        props: {
            lifeskillId: '02',
            tabName: 'practice',
            childTabName: 'games'
        },
        component: DashboardLifeskillView
    },
    {
        path: '/lifeskill/02/practice/systems',
        name: 'DashboardLifeskillViewActiveSystemsTab',
        props: {
            lifeskillId: '02',
            tabName: 'practice',
            childTabName: 'systems'
        },
        component: DashboardLifeskillView
    },
    {
        path: '/lifeskill/:lifeskillId/:tabName',
        name: 'DashboardLifeskillViewWithTab',
        props: true,
        component: DashboardLifeskillView
    },
    {
        path: '/lifeskill/:lifeskillId/scenario/:stepId/:scenarioIndex',
        name: 'DashboardScenarioView',
        props: route => ({
            lifeskillId: route.params.lifeskillId,
            stepId: route.params.stepId,
            scenarioIndex: parseInt(route.params.scenarioIndex, 10)
        }),
        component: DashboardScenarioView
    },

    {
        path: '/follow',
        name: 'FollowLifeskillView',
        component: DashboardLifeskillsFavoritesView
    },
    {
        path: '/onboarding/intro',
        name: 'DashboardOnboardingIntroView',
        component: DashboardOnboardingIntroView
    },
    {
        path: '/vote',
        component: DashboardLifeskillsVoteView
    },
    {
        path: '/mh',
        component: MentalHygieneView
    }
];
